import type React from "react";

export const VolleyballIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill={color}
      {...restProps}
    >
      <title>Volleyball Icon</title>
      <path d="M12 3.027a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5zm-10.75 9.25C1.25 6.34 6.063 1.527 12 1.527s10.75 4.813 10.75 10.75-4.813 10.75-10.75 10.75-10.75-4.813-10.75-10.75z" />
      <path d="M8.32 2.554c.399.11.634.523.524.922-.37 1.34-.343 4.81 3.01 7.482 4.836-1.234 8.535-.804 10.65 1.113a.75.75 0 1 1-1.008 1.112c-1.516-1.375-4.48-1.944-9.007-.837.243 4.745-3.217 7.724-5.18 8.614a.75.75 0 0 1-.619-1.366c1.657-.75 4.616-3.348 4.284-7.418C7.02 9.064 6.896 4.899 7.397 3.078a.75.75 0 0 1 .923-.524z" />
      <path d="M14.055 7.114c-2.003.236-3.665.918-4.552 1.72L8.497 7.72c1.2-1.085 3.201-1.84 5.383-2.096 2.2-.26 4.695-.026 6.929.983l-.618 1.367c-1.94-.877-4.152-1.094-6.136-.86zM15.364 16.525c.798-1.956 1.044-3.846.79-5.098l1.47-.3c.334 1.643-.007 3.847-.871 5.965-.871 2.132-2.313 4.28-4.3 5.783l-.906-1.196c1.728-1.308 3.024-3.213 3.817-5.154zM6.722 12.786c1.113 1.905 2.477 3.275 3.603 3.815l-.65 1.352c-1.5-.72-3.056-2.37-4.248-4.41C4.225 11.482 3.334 8.927 3.25 6.3l1.5-.048c.074 2.332.87 4.647 1.972 6.533z" />
    </svg>
  );
};
